<template>
    <div id="shop-sort" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#sort" href="/build/assets/icons.svg#sort" />
                </svg>
                Sort By
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>
        <div class="offcanvas__body">
            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading hidden-md">
                    <!--
                    This is ugly but thats not a me problem :)
                    The designs have breadcrumbs, we need to add those
                    -->
                    <h3>{{ collection ? collection.name + (group ? ` > ` + group.name : '') : 'Products' }}</h3>
                </div>
                <select class="form-select" v-model="sort">
                    <option
                        v-for="opt in sorted_options"
                        :key="opt.value"
                        :value="opt.value"
                    >
                        {{ opt.value === sort ? `Sort: ${opt.label}` : opt.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div id="shop-filter" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#refine" href="/build/assets/icons.svg#refine" />
                </svg>
                Refine
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>

        <div class="offcanvas__body">
            <!-- Desktop Search (inside offcanvas) -->
            <div v-if="shouldShowSearch" class="shop-sidebar__section desktop-search">
                <div class="search-input-wrapper">
                    <svg class="search-icon" focusable="false" role="img" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.35-4.35"></path>
                    </svg>
                    <input
                        type="text"
                        class="form-control search-input-with-icon"
                        placeholder="Search products..."
                        v-model="searchQuery"
                        @keyup.enter="submitSearch"
                    />
                    <button
                        v-if="searchQuery"
                        type="button"
                        class="search-clear-btn"
                        @click="clearSearch"
                        aria-label="Clear search"
                    >
                        &times;
                    </button>
                </div>
            </div>

            <div
                class="shop-sidebar__section"
                v-for="(options, groupKey) in filters.filters"
                :key="groupKey"
            >
                <div class="shop-sidebar__section__heading">
                    <h3>{{ formatLabel(groupKey) }}</h3>
                </div>

                <div class="form-check" v-for="value in options" :key="value">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`${groupKey}_${value}`"
                        :value="value"
                        :checked="selected_filters[groupKey]?.includes(value)"
                        @change="updateFilters(groupKey, value)"
                    />
                    <label class="form-check-label" :for="`${groupKey}_${value}`">
                        {{ filters.labels[value] }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
    filters: Object,
    collection: Object|Array,
    group: Object|Array|null,
    selected_filters: Object,
    showSearch: {
        type: [Boolean, String],
        default: true,
    },
    initial_sort: {
        type: String,
        default: 'title_asc',
    },
    initial_search: {
        type: String,
        default: '',
    },
})

const shouldShowSearch = computed(() => {
    return props.showSearch === true || props.showSearch === 'true'
})

const sort = ref(props.initial_sort)
const searchQuery = ref(props.initial_search)
const sort_options = [
    { value: 'title_asc',   label: 'Product Name (A–Z)' },
    { value: 'title_desc',  label: 'Product Name (Z–A)' },
    { value: 'from_price_asc',  label: 'Price (Low to High)' },
    { value: 'from_price_desc', label: 'Price (High to Low)' },
];

const active_option = computed(
    () => sort_options.find(o => o.value === sort.value) || sort_options[0]
)

const other_options = computed(
    () => sort_options.filter(o => o.value !== sort.value)
)

const sorted_options = computed(
    () => [active_option.value, ...other_options.value]
)

watch(sort, newVal => {
    emit('update', 'sort', newVal)
})

const emit = defineEmits(['update', 'clear', 'search'])

// Debounce helper
const debounce = (fn, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
    };
};

// Auto-search after 300ms of no typing
const debouncedSearch = debounce((query) => {
    emit('search', query);
}, 300);

watch(searchQuery, (newVal) => {
    debouncedSearch(newVal);
})

const updateFilters = (category, value) => {
    emit('update', category, value)
}

const clearFilter = () => {
    searchQuery.value = ''
    emit('clear')
}

const submitSearch = () => {
    emit('search', searchQuery.value)
}

const clearSearch = () => {
    searchQuery.value = ''
    emit('search', '')
}


const formatLabel = (key) => {

    if (props.filters.custom_names && props.filters.custom_names[key.toLowerCase()]) {
        return props.filters.custom_names[key.toLowerCase()];
    }

    // TODO : This really really should pull from the landlord data...
    return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
}
</script>
